import * as coreClient from "@azure/core-client";

export const CreateCustomerRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CreateCustomerRequest",
    modelProperties: {
      parentAccountId: {
        serializedName: "parentAccountId",
        nullable: true,
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        required: true,
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        required: true,
        type: {
          name: "String"
        }
      },
      telephoneNumber: {
        serializedName: "telephoneNumber",
        type: {
          name: "String"
        }
      },
      status: {
        serializedName: "status",
        type: {
          name: "String"
        }
      },
      marketingPreferences: {
        serializedName: "marketingPreferences",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MarketingPreference"
            }
          }
        }
      },
      address: {
        serializedName: "address",
        type: {
          name: "Composite",
          className: "Address"
        }
      },
      bankAccount: {
        serializedName: "bankAccount",
        type: {
          name: "Composite",
          className: "BankAccount"
        }
      }
    }
  }
};

export const MarketingPreference: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MarketingPreference",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      optIn: {
        serializedName: "optIn",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const Address: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Address",
    modelProperties: {
      department: {
        serializedName: "department",
        type: {
          name: "String"
        }
      },
      company: {
        serializedName: "company",
        type: {
          name: "String"
        }
      },
      address1: {
        serializedName: "address1",
        required: true,
        type: {
          name: "String"
        }
      },
      address2: {
        serializedName: "address2",
        nullable: true,
        type: {
          name: "String"
        }
      },
      address3: {
        serializedName: "address3",
        nullable: true,
        type: {
          name: "String"
        }
      },
      town: {
        serializedName: "town",
        required: true,
        type: {
          name: "String"
        }
      },
      county: {
        serializedName: "county",
        type: {
          name: "String"
        }
      },
      postCode: {
        serializedName: "postCode",
        required: true,
        type: {
          name: "String"
        }
      },
      country: {
        serializedName: "country",
        type: {
          name: "String"
        }
      },
      localAuthority: {
        serializedName: "localAuthority",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const BankAccount: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "BankAccount",
    modelProperties: {
      bankName: {
        serializedName: "bankName",
        required: true,
        type: {
          name: "String"
        }
      },
      branchName: {
        serializedName: "branchName",
        type: {
          name: "String"
        }
      },
      accountNumber: {
        serializedName: "accountNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      sortCode: {
        serializedName: "sortCode",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const Customer: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Customer",
    modelProperties: {
      parentAccountId: {
        serializedName: "parentAccountId",
        nullable: true,
        type: {
          name: "String"
        }
      },
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        required: true,
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        required: true,
        type: {
          name: "String"
        }
      },
      telephoneNumber: {
        serializedName: "telephoneNumber",
        type: {
          name: "String"
        }
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "String"
        }
      },
      marketingPreferences: {
        serializedName: "marketingPreferences",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MarketingPreference"
            }
          }
        }
      },
      address: {
        serializedName: "address",
        type: {
          name: "Composite",
          className: "Address"
        }
      },
      createdDate: {
        constraints: {
          Pattern: new RegExp("YYYY-MM-DDThh:mm:ss")
        },
        serializedName: "createdDate",
        type: {
          name: "String"
        }
      },
      bankAccount: {
        serializedName: "bankAccount",
        type: {
          name: "Composite",
          className: "BankAccount"
        }
      }
    }
  }
};

export const ApiError: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApiError",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "Number"
        }
      },
      shortDescription: {
        serializedName: "shortDescription",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UpdateCustomerRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "UpdateCustomerRequest",
    modelProperties: {
      parentAccountId: {
        serializedName: "parentAccountId",
        nullable: true,
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        required: true,
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        required: true,
        type: {
          name: "String"
        }
      },
      telephoneNumber: {
        serializedName: "telephoneNumber",
        type: {
          name: "String"
        }
      },
      status: {
        serializedName: "status",
        type: {
          name: "String"
        }
      },
      marketingPreferences: {
        serializedName: "marketingPreferences",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MarketingPreference"
            }
          }
        }
      },
      address: {
        serializedName: "address",
        type: {
          name: "Composite",
          className: "Address"
        }
      },
      bankAccount: {
        serializedName: "bankAccount",
        type: {
          name: "Composite",
          className: "BankAccount"
        }
      }
    }
  }
};

export const CustomerProfileUploadResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomerProfileUploadResponse",
    modelProperties: {
      imageResource: {
        serializedName: "imageResource",
        type: {
          name: "String"
        }
      },
      dateUploaded: {
        constraints: {
          Pattern: new RegExp("YYYY-MM-DDThh:mm:ss")
        },
        serializedName: "dateUploaded",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const MobileAppVerifyRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MobileAppVerifyRequest",
    modelProperties: {
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const MobileAppVerifyStatus: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "MobileAppVerifyStatus",
    modelProperties: {
      status: {
        defaultValue: "available",
        isConstant: true,
        serializedName: "status",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const SwiftCardCheckStatus: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SwiftCardCheckStatus",
    modelProperties: {
      status: {
        serializedName: "status",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ApplicantCustomer: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApplicantCustomer",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      firstName: {
        serializedName: "firstName",
        required: true,
        type: {
          name: "String"
        }
      },
      lastName: {
        serializedName: "lastName",
        required: true,
        type: {
          name: "String"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      },
      dateOfBirth: {
        serializedName: "dateOfBirth",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ApplicantSwiftcardsRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ApplicantSwiftcardsRequest",
    modelProperties: {
      billingCustomerEmail: {
        serializedName: "billingCustomerEmail",
        required: true,
        type: {
          name: "String"
        }
      },
      applicantCustomerID: {
        serializedName: "applicantCustomerID",
        type: {
          name: "String"
        }
      },
      ticketID: {
        serializedName: "ticketID",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const CustomerSwiftCard: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomerSwiftCard",
    modelProperties: {
      cardNumber: {
        serializedName: "cardNumber",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
